import { Trans } from '@lingui/react/macro';

import { trpc } from '@/services/trpc';

export function AccessPropagationBanner({
  folderId,
  chatId,
  documentId,
}: {
  folderId?: string | null;
  chatId?: string;
  documentId?: string;
}) {
  const { data } = trpc.documentFolders.accessPropagationStatus.useQuery(
    { folderId: folderId ?? null, chatId, documentId },
    { refetchInterval: 5000 },
  );
  if (!data?.total) return null;

  return (
    <div
      role='status'
      className='mb-3 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900'
    >
      <p>
        <Trans>
          Access updates pending: {data.pending}. Failed: {data.failed}.
        </Trans>
      </p>
      <p>
        <Trans>
          Search results may not reflect the latest access settings until these
          updates finish.
        </Trans>
      </p>
    </div>
  );
}
